import React from "react";

/**
 * Lucide "link-2" stroke glyph — two chain halves with a break line.
 * Used on Capture detach actions (unlink from wheel).
 */
const Link2LineArt = ({
  color = "#8F38EF",
  width = 20,
  height = 20,
  strokeWidth = 2,
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-link-2"
    aria-hidden="true"
    {...rest}
  >
    <path d="M9 17H7A5 5 0 0 1 7 7h2" />
    <path d="M15 7h2a5 5 0 1 1 0 10h-2" />
    <line x1="8" x2="16" y1="12" y2="12" />
  </svg>
);

export default Link2LineArt;
